import { useHistory, useLocation } from "react-router-dom";
import qs from "qs";

const useQueryManager = () => {
	const history = useHistory();
	const location = useLocation();

		const getQuery = () => {
		const queryString = location.search.slice(1);
		const parsed = qs.parse(queryString);
		return parsed;
	};
	// 決定是否要進入頁面時抓取資料
	// void
	const setQuery = (queryObject, replace = true) => {
		const queryString = qs.stringify(queryObject, {
			arrayFormat: "repeat",
			skipNulls: true,
		});
		const url = location.pathname + "?" + queryString;
		replace ? history.replace(url) : history.push(url);
	};

	return { searchParams: qs.parse(getQuery()), setQuery, getQuery };
};

export default useQueryManager;
